import { useGetSelectedProjectQuery } from '@/serverStore/projects';
import { ProjectRole, UserPermission } from '@clef/shared/types';

/**
 * get project role and permissions for the current user
 */
export const useProjectRolePermissions = () => {
  const { data: project } = useGetSelectedProjectQuery();

  const { permissions = [], role = ProjectRole.Standard } = project?.currentUserPermission ?? {};

  return { inviteOnly: project?.inviteOnly, projectRole: role, permissions };
};

/**
 * check if current user has a specified project-level permission
 * @param permission UserPermission
 */
export const useHasPermission = (permission: UserPermission) => {
  const { inviteOnly, projectRole, permissions } = useProjectRolePermissions();
  if (!inviteOnly || projectRole === ProjectRole.Owner) {
    return true;
  }
  if (projectRole === ProjectRole.Labeler) {
    return false;
  }
  return permissions.includes(permission);
};
